/* Protection colis US (MLP).
   Lit la config posée par snippets/mlp-protection-config.liquid (window.MLPProtectionConfig).
   API pour notre tiroir panier :
     MLPProtection.checkout(true|false)  ajoute (ou retire) le bon palier puis part au paiement
     MLPProtection.sync()                à appeler après chaque changement du panier : corrige le palier,
                                         retire la protection hors US ou si elle reste seule
     MLPProtection.subtotal(cart)        total du panier SANS la protection (cents) : base des paliers
                                         cadeaux, barres « plus que X » et upsells
     MLPProtection.isProtection(item)    vrai si la ligne est la protection (pour la cacher)
   Événement émis après une modification : document 'mlp:protection:change' (detail = panier à jour). */
(() => {
  const C = window.MLPProtectionConfig;
  if (!C || !C.productId) return;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const VIDS = C.variantIds.map(Number); // triées par prix croissant
  const CUTS = C.cuts.map(Number);       // en cents : total >= CUTS[i] => palier i + 1

  const isProtection = (item) => Number(item.product_id) === Number(C.productId);
  const subtotal = (cart) => cart.items.reduce((t, it) => (isProtection(it) ? t - it.final_line_price : t), cart.total_price);
  const tierVariant = (cart) => {
    const total = subtotal(cart);
    let tier = 0;
    CUTS.forEach((cut, i) => { if (total >= cut) tier = i + 1; });
    return VIDS[Math.min(tier, VIDS.length - 1)];
  };
  const getCart = async () => (await fetch(ROOT + 'cart.js', { credentials: 'same-origin' })).json();
  const update = async (body) => {
    const r = await fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const cart = await r.json();
    document.dispatchEvent(new CustomEvent('mlp:protection:change', { detail: cart }));
    return cart;
  };
  // Chaque variante par son id : 1 pour la bonne, 0 pour les autres. Jamais 2 lignes, même avec 2 onglets.
  const updatesFor = (vid) => VIDS.reduce((u, id) => { u[id] = id === vid ? 1 : 0; return u; }, {});

  // État voulu du panier : protection au bon palier, ou aucune. Ne touche au panier que si besoin.
  let syncing = null;
  const sync = (cart) => {
    if (syncing) return syncing;
    syncing = (async () => {
      cart = cart || (await getCart());
      const lines = cart.items.filter(isProtection);
      if (!lines.length) return cart;
      const others = cart.items.length - lines.length;
      let want = 0;
      if (C.eligible && others > 0) want = tierVariant(cart);
      const ok = want && lines.length === 1 && lines[0].variant_id === want && lines[0].quantity === 1;
      if (ok) return cart;
      return update({ updates: updatesFor(want) });
    })().finally(() => { syncing = null; });
    return syncing;
  };

  const checkout = async (want) => {
    try {
      // Palier recalculé au clic, sur le panier réel : jamais un prix périmé.
      const cart = await getCart();
      const vid = want && C.eligible ? tierVariant(cart) : 0;
      // Attribut caché (visible dans la commande) : mesure de la prise, express = attribut absent.
      await update({ updates: updatesFor(vid), attributes: { _protection_colis: vid ? 'oui' : 'non' } });
    } catch (e) {
      // En cas de souci, on part quand même au paiement : on ne bloque jamais une vente.
    }
    window.location.href = ROOT + 'checkout';
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pp-go]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled) return;
    btn.closest('[data-pp]').querySelectorAll('[data-pp-go]').forEach((b) => { b.disabled = true; });
    checkout(btn.dataset.ppGo === '1');
  });

  // Retour du paiement, changement de pays, panier modifié ailleurs : on remet le panier d'aplomb.
  if (C.inCart) sync().catch(() => {});
  ['cart:change', 'cart:refresh', 'cart:updated'].forEach((name) => {
    document.addEventListener(name, (e) => {
      const cart = e.detail && e.detail.cart && e.detail.cart.items ? e.detail.cart : null;
      sync(cart).catch(() => {});
    });
  });

  window.MLPProtection = { checkout, sync, subtotal, tierVariant, isProtection, config: C };
})();
